import a from "./index800.js";
import i from "./index876.js";
import n from "./index913.js";
var e = Object.prototype, p = e.hasOwnProperty;
function v(r) {
  if (!a(r))
    return n(r);
  var s = i(r), o = [];
  for (var t in r)
    t == "constructor" && (s || !p.call(r, t)) || o.push(t);
  return o;
}
export {
  v as default
};
